import { useEffect } from 'react';

import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import ChooseRepaymentAmount from './chooseRepaymentAmount/ChooseRepaymentAmount';
import ConfirmRepayment from './confirmRepayment/ConfirmRepayment';
import {
    ACTIVATE_EARLY_REPAYMENT,
    LEAVE_EARLY_REPAYMENT
} from './EarlyRepayment.actions';
import { getEarlyRepaymentStripeKey } from './EarlyRepaymentSelector';
import { TruelayerConfirmation } from './truelayer/TruelayerConfirmation';
import IwStripeProvider from '../../iwStripeProvider/IwStripeProvider';
import { useTrackPageView } from '../../tracking/pageView';
import { MainContentBlockPending } from '../pageStructure/mainContentBlockPending/MainContentBlockPending';

const mapStateToProps = (state: RootState) => ({
    ...state.earlyRepayment,
    stripeKey: getEarlyRepaymentStripeKey(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    activate: () => dispatch({ type: ACTIVATE_EARLY_REPAYMENT }),
    leave: () => dispatch({ type: LEAVE_EARLY_REPAYMENT })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const EarlyRepayment = (props: PropsFromRedux) => {
    const { ready, step, stripeKey, activate, leave } = props;

    useTrackPageView({ name: 'Early Repayment' });

    useEffect(() => {
        activate();

        return () => {
            leave();
        };
    }, [activate, leave]);

    if (ready) {
        switch (step) {
            case 'CHOOSE_REPAYMENT_AMOUNT':
                return <ChooseRepaymentAmount {...props} />;
            case 'CONFIRM_REPAYMENT':
                return (
                    // @ts-expect-error component not yet in TS
                    <IwStripeProvider stripeKey={stripeKey}>
                        <ConfirmRepayment />;
                    </IwStripeProvider>
                );
            case 'SHOW_TRUELAYER_CONFIRMATION':
                return <TruelayerConfirmation />;
        }
    }

    return <MainContentBlockPending data-testid="early-repayment-loading" />;
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(EarlyRepayment);
